import { render, staticRenderFns } from "./PuInvoice.vue?vue&type=template&id=466c18fc&"
import script from "./PuInvoice.vue?vue&type=script&lang=js&"
export * from "./PuInvoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports